import { Box, Card, Typography } from '@mui/material';
import React from 'react'
import Loading from '../../../components/Loader/Loading';
import ExportFinalPayout from './ExportFinalPayout';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../../components/pagination/CustomPagination';

const FinalPayout = (props) => {
    const {rows, loading, startDate, endDate} = props;
    const columns=[
        { field: 'expert_id', sortable:false ,headerName: 'Seller_ID', width: 180, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Seller_ID</span>,
            renderCell: (params) =>(
                <Typography color="primary" sx={{fontSize:'.65rem',cursor:'pointer'}} >
                    {params.value}
                    {/* {' '} */}
                    {/* {params.row.customerId == params.row.createdBy && <PhoneAndroid sx={{fontSize:'.65rem'}} color='warning'/>} */}
                </Typography>
            )
        },
        
        {
            field: 'expert_name', sortable:false ,headerName: 'Seller_Name', width: 150, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Seller_Name</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        {
            field: 'start_date', sortable:false ,headerName: 'Week_Start_Date', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Week_Start_Date</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )

        },
        {
            field: 'end_date', sortable:false ,headerName: 'Week_End_Date', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Week_End_Date</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )

        },
        {
            field: 'total_bookings', sortable:false ,headerName: 'Order_Count', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Order_Count</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )

        },
        {
            field: 'total_payable_amount', sortable:false ,headerName: 'Net_Payable', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Net_Payable</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )

        },
        {
            field: 'payout_cycle_date', sortable:false ,headerName: 'Payout_Date', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Payout_Date</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )

        },
        {
            field: 'Payout_Status', sortable:false ,headerName: 'Payout_Status', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Payout_Status</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>Pending</Typography>
                </Box>
            )

        },
        { field: 'beneficiary_name', sortable:false ,headerName: 'BANK ACCOUNT NAME', width: 150, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>BANK ACCOUNT NAME</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'account_number', sortable:false ,headerName: 'BANK ACCOUNT NUMBER', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>BANK ACCOUNT NUMBER</span> ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'bank_name', sortable:false ,headerName: 'BANK NAME', width: 110, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>BANK NAME</span>,
            // valueFormatter: (params) => ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'ifsc_code', sortable:false ,headerName: 'IFSC CODE', width: 160, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>IFSC CODE</span> ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        }
    ]

  return (
    <>
      <Card sx={{mt:1}}>
        <Box sx={{borderBottom:'1px solid #ECECEC', p:'0.25% 1%', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
            <Typography sx={{ fontWeight: '500', fontSize: '0.85rem' }}>Final Payout</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
                <Typography variant="body2" sx={{fontSize:'.75rem',color:'text.secondary'}}>
                    Report Period : {startDate} To {endDate}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
                {rows.length > 0 && (
                    <ExportFinalPayout rows = {rows} startDate={startDate} endDate={endDate} />
                )}
            </Box>
        </Box>
        <Box sx={{ overflow: "auto" }}>
            <Box 
                sx={{ 
                width: "100%", display: "table",  tableLayout: "fixed", 
                backgroundColor: "#fff", borderRadius: '.5rem',
                '& .odd': {
                    bgcolor: 'white',
                },
                '& .even': {
                    bgcolor: '#ECECEC',
                },
                }}>
    
            {loading && <Loading/>}
                
                <DataGrid
                    rows={rows.map((row, index) => ({ ...row, id: `${row?.bookingNumber}-${index}` }))}
                    columns={columns.map((col) => ({
                        ...col,
                        flex: col.flex || 1, // Ensure columns resize dynamically
                        minWidth: col.minWidth || 150, // Set a minimum width to avoid overlap
                    }))}
                    getRowId={(row) => row?.id}
                    rowCount={rows && rows.length > 0 ? rows.length : 0} // Use totalRecords from API response
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    
                    showFirstButton={true}
                    showLastButton={true}

                    disableMultiSort={true}
        
                    loading={loading}
                    disableColumnMenu
                    disableRowSelectionOnClick
                    disableDensitySelector
                    sortingOrder={['asc', 'desc']}
                    slots={{
                        // toolbar: GridToolbar,
                        loadingOverlay: Loading,
                        // Optionally use custom pagination
                        pagination: CustomPagination,
                    }}
                    autoHeight
                    getRowHeight={() => 'auto'}
                    sx={{
                 minWidth: "100%", // Ensures DataGrid expands inside scrollable container
                        "& .MuiDataGrid-root": {
                        overflowX: "auto",
                        },
                  height:'68vh',
                    borderRadius:'0',
                    '& .MuiDataGrid-cell': {
                    border: 1,
                    borderRight: 0,
                    borderTop: 0,
                    borderColor: 'lightgrey',
                    display: 'flex',
                    alignItems: 'center',
                    // justifyContent: 'center',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                    //   borderTop: '2px solid rgba(224, 224, 224, 1)',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        p:0,
                        minHeight:'0 !important',
                        height:'2rem'
                    },
                    '& .MuiDataGrid-columnHeader': {
                    borderLeft: '1px solid rgba(224, 224, 224, 1)',
                    borderBottom: 'none',
                    '&:first-child': {
                        borderLeft: 'none',
                    },
                    '&:last-child': {
                        borderRight: 'none',
                    },
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 600,
                    color: '#3e3e3e'
                    },
                    '& .MuiDataGrid-row': {
                        '& .MuiDataGrid-cell': {
                            py:1
                        },
                        // Add styles for deleted rows
                        '&.deleted-row': {
                            backgroundColor: '#ffebee !important', // Light red background
                            '&:hover': {
                            backgroundColor: '#ffcdd2 !important', // Darker red on hover
                            }
                        },
                        '& .MuiDataGrid-cell:first-child': {
                        borderLeft: 'none',
                    },
                    '&:last-child .MuiDataGrid-cell': {
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    },
                    '& .MuiDataGrid-cell:last-child': {
                        borderRight: 'none',
                    },
                    },
                    '& .MuiDataGrid-columnSeparator': {
                    display: 'none',
                    },
                }}
                    />
                </Box>
            </Box>
        </Card>
    </>
  )
}

export default FinalPayout
